import React, { Component } from 'react'
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { Button, Card, CardBody, Col, Label, Row } from 'reactstrap';
import { Preloading } from '../../components/UI/Preloader/action';
import Table from "../../components/UI/Table/Table";
import { corporateMasterDataUpload, corporateMasterTemplateRequest, corporateMasterListRequest, corporateMasterDataExcelRequest, corporateMasterGetCorporatesRequest } from './action'
import FileSaver from 'file-saver';
import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from "./CorporateMasterTable/constants"

import CorporateMasterListFilterFrom from "./CorporateMasterFilter/index"

import CorporateMasterTable from "./CorporateMasterTable/index"

import { buildCorporateMasterFetchRequest } from "./helper"
class CoporateMasterUploadUtility extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: "",
      corporateMasterExcelFile: '',
      noExcelUploadWarning: '',
      pageSize: this.props.defaultPageSize || DEFAULT_PAGE_SIZE,
      pageNumber: DEFAULT_PAGE_NUMBER,
      currentFilter: {},
      sorted: [{
        id: "createdAt",
        desc: true
      }]
    };
  }


  componentDidUpdate(prevProps) {

    if (this.props.corporateMasterTemplateSuccess !== prevProps.corporateMasterTemplateSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.corporateMasterTemplateSuccess.data], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, `corporateMasterExcelFile.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.corporateMasterTemplateFailure !== prevProps.corporateMasterTemplateFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }

    if (this.props.addCorporateMasterUploadSuccess !== prevProps.addCorporateMasterUploadSuccess) {
      this.props.preloading(false)
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp; {this.props.addCorporateMasterUploadSuccess}
        </div>
      );
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    }
    if (this.props.addCorporateMasterUploadFailure !== prevProps.addCorporateMasterUploadFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp; {this.props.addCorporateMasterUploadFailure.data.message}
        </div>
      );
    }

    if (this.props.corporateMasterDataExcelSuccess !== prevProps.corporateMasterDataExcelSuccess) {
      this.props.preloading(false)
      var blob = new Blob([this.props.corporateMasterDataExcelSuccess.data], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, `Corporate_Master_Data.xlsx`);
      toast.success(
        <div>
          <i className="fa fa-check-circle fa-lg"></i>&nbsp;File Downloaded Successfully
        </div>
      );
    }
    if (this.props.corporateMasterDataExcelFailure !== prevProps.corporateMasterDataExcelFailure) {
      this.props.preloading(false)
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Some error occured<br />&nbsp;Please try again!
        </div>
      );
    }
  }

  openFilter = () => {
    this.setState({ showFilter: true });
  };

  closeFilter = () => {
    this.setState({ showFilter: false });
  };

  onSortedChange = (sorted) => {
    this.setState({
      sorted: sorted[0],
      pageNumber: DEFAULT_PAGE_NUMBER
    }, () => {
      this.fetchCorporateMasterList();
    })
  }

  fetchCorporateMasterList = () => {
    const { pageNumber, pageSize, currentFilter, sorted } = this.state;
    const requestBody = buildCorporateMasterFetchRequest({ pageNumber, pageSize, filter: currentFilter, sorted });
    this.props.corporateMasterListRequest(requestBody);
  }

  componentDidMount() {
    this.props.corporateMasterGetCorporatesRequest();
    this.fetchCorporateMasterList();
  }

  handleApplyFilter = (filter) => {
    this.setState({
      showFilter: false,
      currentFilter: filter,
      pageNumber: DEFAULT_PAGE_NUMBER

    }, () => {
      this.fetchCorporateMasterList();
    });

  };

  onPageChange = (pageIndex) => {
    this.setState({
      pageNumber: pageIndex
    }, () => {
      this.fetchCorporateMasterList();
    });
  };

  onPageSizeChange = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: DEFAULT_PAGE_NUMBER
    }, () => {
      this.fetchCorporateMasterList();
    });
  };

  handleTemplateDownload = () => {
    this.props.preloading(true)
    this.props.corporateMasterTemplateRequest();
  }

  uploadExcel = (event) => {
    this.setState({
      corporateMasterExcelFile: event.target.files[0]
    })
    event.preventDefault();
    event.target.value = null;
  }

  handleDownloadCorporateMasterData = () => {
    this.props.preloading(true)
    this.props.corporateMasterDataExcelRequest();
  }

  handleSubmit = () => {
    if (!this.state.corporateMasterExcelFile) {
      this.setState({ noExcelUploadWarning: '*Please upload the filled request template!' })
    }
    if (this.state.type === '') {
      toast.error(
        <div>
          <i className="fa fa-exclamation-triangle"></i>&nbsp;Please Select Upload Type
        </div>
      );
    }

    else {
      this.props.corporateMasterDataUpload({ file: this.state.corporateMasterExcelFile, type: this.state.type });
      this.props.preloading(true);
    }
  }

  render() {
    const paginatedData = this.props.corporateMasterViewPaginatedList || {};
    const data = paginatedData.content || [];
    const pagination = paginatedData.pageable || {};
    const totalPages = paginatedData.totalPages || 0;
    return (
      <Col>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0 text-center">Corporate Master Upload</h4>
        </div>
        <Card>
          <CardBody>
            <Label>Upload Corporate Master Template</Label>
            <Row>
              <Col sm="22">
                <Button
                  color="primary"
                  onClick={this.handleTemplateDownload}
                  className="btn color-excel-download "
                >
                  <i className="fa fa-file-excel-o fa-lg"></i>
                  &nbsp;&nbsp;Download Template
                </Button>
                <Row
                  color="primary"
                  className="btn btn-primary ml-0 position-relative excel-upload-btn browse-files ml-3"
                  title="Upload Request Template"
                >
                  <input
                    onChange={this.uploadExcel}
                    type="file"
                    name="file"
                    id="file"
                    className="upload-file"
                    title="Upload Request Template"
                    accept=".xlsx"
                  />
                  <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" />{" "}
                  Upload Template
                </Row>
                <Label className="uploadType">Upload Type : </Label>
                <div className="ifscType">
                  <input name="type" type="radio" value="add" onChange={e => { this.setState({ type: e.target.value }) }} />
                  &nbsp;&nbsp;Add New Records
                  <label>
                    <input name="type" type="radio" value="edit" onChange={e => { this.setState({ type: e.target.value }) }} />
                    &nbsp;&nbsp;Update Existing
                  </label>
                </div>
                <Button
                  className="ml-5"
                  color="primary"
                  onClick={this.handleSubmit}
                >
                  Submit
                </Button>
                <Button className="ml-5"
                  color="success" onClick={this.handleDownloadCorporateMasterData}>Download Existing Data</Button>
                <Button className="ml-2" color="primary" onClick={this.openFilter}>
                  <i className="fa fa-filter fa-lg"></i> Apply Filters
                </Button>
                <Row className={(this.state.corporateMasterExcelFile) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text"}>{(this.state.corporateMasterExcelFile) ? this.state.corporateMasterExcelFile.name : this.state.noExcelUploadWarning}</Row>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <CorporateMasterListFilterFrom
          isOpen={this.state.showFilter}
          toggle={this.closeFilter}
          onApply={this.handleApplyFilter}
          currentFilters={this.state.currentFilter}
          corporates={this.props.corporates}
          corporatesLoading={this.props.corporatesLoading}
        />

        <CorporateMasterTable

          paginatedResponse={this.props.corporateMasterViewPaginatedList}
          loading={this.props.loading}
          pageSize={this.state.pageSize}
          pageNumber={this.state.pageNumber}
          onPageChange={this.onPageChange}
          onPageSizeChange={this.onPageSizeChange}
          sorted={this.state.sorted}
          onSortedChange={this.onSortedChange}

        />
      </Col>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  corporateMasterTemplateSuccess: state.corporateMasterReducer.corporateMasterTemplateSuccess,
  corporateMasterTemplateFailure: state.corporateMasterReducer.corporateMasterTemplateFailure,
  addCorporateMasterUploadSuccess: state.corporateMasterReducer.addCorporateMasterUploadSuccess,
  addCorporateMasterUploadFailure: state.corporateMasterReducer.addCorporateMasterUploadFailure,
  corporateMasterDataExcelSuccess: state.corporateMasterReducer.corporateMasterDataExcelSuccess,
  corporateMasterDataExcelFailure: state.corporateMasterReducer.corporateMasterDataExcelFailure,
  corporateMasterViewPaginatedList: state.corporateMasterReducer.corporateMasterListSuccess,
  corporates: state.corporateMasterReducer.corporates || [],
  corporatesLoading: state.corporateMasterReducer.corporatesLoading,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
  corporateMasterTemplateRequest: () => dispatch(corporateMasterTemplateRequest()),
  corporateMasterDataUpload: (data) => dispatch(corporateMasterDataUpload(data)),
  corporateMasterDataExcelRequest: () => dispatch(corporateMasterDataExcelRequest()),
  corporateMasterListRequest: (data) => dispatch(corporateMasterListRequest(data)),
  corporateMasterGetCorporatesRequest: () => dispatch(corporateMasterGetCorporatesRequest()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CoporateMasterUploadUtility);